/**
 * Created by gocey on 28.08.17.
 */

Box.Application.addModule('sv-hotspots', function(context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _prepareCanvas = function() {
        _self.$element = $(context.getElement());
    };

    var _initCanvas = function() {
        var canvas = document.getElementById('item'),
            context = canvas.getContext('2d');

        context.beginPath();
        context.moveTo(0, 100);
        context.lineTo(300, 50);
        context.stroke();

        context.beginPath();
        context.moveTo(150, 50);
        context.lineTo(250, 550);
        context.stroke();

        context.beginPath();
        context.moveTo(150, 50);
        context.lineTo(50, 250);
        context.stroke();

        context.beginPath();
        context.moveTo(150, 50);
        context.lineTo(250, 250);
        context.stroke();
    };

    return {

        init: function() {
            _prepareCanvas();
            _initCanvas();
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-hotspots.js